//helper goes here for skills
// import photoshop from "../../assets/icons/photoshop.png"
// import dreamweaver from "../../assets/icons/dreamweaver.png"
// import flash from "../../assets/icons/flash.png"
// import illustrator from "../../assets/icons/illustrator.png"
// import word from "../../assets/icons/word.svg"
// import excel from "../../assets/icons/excel.svg"
// import powerpoint from "../../assets/icons/powerpoint.svg"
// import publisher from "../../assets/icons/publisher.svg"
// import outlook from "../../assets/icons/outlook.svg"

export type SkillsProps = {}
export const skills = [
    {
        category: "Programming",
        skillset: [
            { img: require(`../../assets/icons/java.png`), alt: "Java" },
            { img: require(`../../assets/icons/ts.png`), alt: "TypeScript" },
            { img: require(`../../assets/icons/python.png`), alt: "Python" },
            { img: require(`../../assets/icons/cpp.png`), alt: "C++" },
            { img: require(`../../assets/icons/c.png`), alt: "C" }]
    },
    {
        category: "Backend",
        skillset: [
            { img: require(`../../assets/icons/spring.png`), alt: "SpringBoot" },
            { img: require(`../../assets/icons/express.png`), alt: "ExpressJS" },
            { img: require(`../../assets/icons/flask.png`), alt: "Flask" },
        ]
    },
    {
        category: "Frontend",
        skillset: [
            { img: require(`../../assets/icons/reactjs.png`), alt: "React" },
            { img: require(`../../assets/icons/angular.png`), alt: "Angular" },
            { img: require(`../../assets/icons/mui.png`), alt: "Material-UI" },
            { img: require(`../../assets/icons/bootstrap.png`), alt: "Bootstrap" },
            { img: require(`../../assets/icons/html.png`), alt: "HTML" },
            { img: require(`../../assets/icons/css.png`), alt: "CSS" },
            { img: require(`../../assets/icons/js.png`), alt: "JavaScript" },
            { img: require(`../../assets/icons/jquery.png`), alt: "jQuery" }
        ]
    },
    {
        category: "Databases",
        skillset: [
            { img: require(`../../assets/icons/mongodb.png`), alt: "MongoDB" },
            { img: require(`../../assets/icons/sql.png`), alt: "SQL" },

        ]
    },
    {
        category: "Tools",
        skillset: [
            { img: require(`../../assets/icons/git.png`), alt: "Git" },
            { img: require(`../../assets/icons/bash.png`), alt: "Bash" },
            { img: require(`../../assets/icons/linux.png`), alt: "Linux" },
            { img: require(`../../assets/icons/nodejs.png`), alt: "Node.js" },
            { img: require(`../../assets/icons/maven.png`), alt: "Maven" },
            { img: require(`../../assets/icons/netlify.png`), alt: "Netlify" }

        ]
    },
    // {
    //     category:"Adobe",
    //     skillset:[
    //         {img: photoshop, alt:"Photoshop"},
    //         {img: dreamweaver, alt:"Dreamweaver"},
    //         {img: illustrator, alt: "Illustrator"},
    //         {img: flash, alt: "Flash"},
    //     ]

    // },
    // {
    //     category:"Microsoft Office",
    //     skillset:[
    //         {img: word, alt:"Word"},
    //         {img: excel, alt:"Excel"},
    //         {img: powerpoint, alt: "PowerPoint"},
    //         {img: publisher, alt: "Publisher"},
    //         {img: outlook, alt: "Outlook"},
    //     ]
    // },


]
export { }
